"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var EnhancedInput_component_exports = {};
__export(EnhancedInput_component_exports, {
  EnhancedInput: () => EnhancedInput
});
module.exports = __toCommonJS(EnhancedInput_component_exports);
var import_react = __toESM(require("react"));
var import_uniqueId = __toESM(require("lodash/uniqueId"));
var import_atoms = require("../../atoms");
var import_Icon = require("../../atoms/Icon/Icon.component");
var import_EnhancedInput = require("./EnhancedInput.styled");
var _excluded = ["readOnly", "valid", "handleOnChange", "disabled", "required", "darkMode"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r)
      return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t)
          return;
        f = false;
      } else
        for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true)
          ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r))
    return r;
}
function _objectWithoutProperties(e, t) {
  if (null == e)
    return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++)
      o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r)
    return {};
  var t = {};
  for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
      if (e.includes(n))
        continue;
      t[n] = r[n];
    }
  return t;
}
var EnhancedInput = function EnhancedInput2(_ref) {
  var _ref$readOnly = _ref.readOnly, readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly, _ref$valid = _ref.valid, valid = _ref$valid === void 0 ? true : _ref$valid, handleOnChange = _ref.handleOnChange, _ref$disabled = _ref.disabled, disabled = _ref$disabled === void 0 ? false : _ref$disabled, _ref$required = _ref.required, required = _ref$required === void 0 ? false : _ref$required, _ref$darkMode = _ref.darkMode, darkMode = _ref$darkMode === void 0 ? false : _ref$darkMode, props = _objectWithoutProperties(_ref, _excluded);
  var variant = valid ? "regular" : "invalid";
  var _useState = (0, import_react.useState)(), _useState2 = _slicedToArray(_useState, 2), inputValue = _useState2[0], setInputValue = _useState2[1];
  var _useState3 = (0, import_react.useState)(false), _useState4 = _slicedToArray(_useState3, 2), isTitleEllipsisActive = _useState4[0], setIsTitleEllipsisActive = _useState4[1];
  var _useState5 = (0, import_react.useState)(false), _useState6 = _slicedToArray(_useState5, 2), isErrorEllipsisActive = _useState6[0], setIsErrorEllipsisActive = _useState6[1];
  var _useState7 = (0, import_react.useState)(false), _useState8 = _slicedToArray(_useState7, 2), isInfoEllipsisActive = _useState8[0], setIsInfoEllipsisActive = _useState8[1];
  var inputId = "input-id-".concat((0, import_uniqueId.default)());
  var titleLabelRef = (0, import_react.useRef)(null);
  var errorLabelRef = (0, import_react.useRef)(null);
  var infoTextLabelRef = (0, import_react.useRef)(null);
  var inputRef = (0, import_react.useRef)(null);
  var isAriaDisabled = !!props["aria-disabled"];
  (0, import_react.useEffect)(function() {
    var titleElement = titleLabelRef && titleLabelRef.current;
    var errorLabelElement = errorLabelRef && errorLabelRef.current;
    var infoTextLabelElement = infoTextLabelRef && infoTextLabelRef.current;
    if (titleElement) {
      var titleLabelEllipsisStatus = titleElement.offsetWidth < titleElement.scrollWidth;
      setIsTitleEllipsisActive(titleLabelEllipsisStatus);
    }
    if (errorLabelElement) {
      var errorLabelEllipsisStatus = errorLabelElement.offsetWidth < errorLabelElement.scrollWidth;
      setIsErrorEllipsisActive(errorLabelEllipsisStatus);
    }
    if (infoTextLabelElement) {
      var infoLabelEllipsisStatus = infoTextLabelElement.offsetWidth < infoTextLabelElement.scrollWidth;
      setIsInfoEllipsisActive(infoLabelEllipsisStatus);
    }
    if (props.value) {
      var inputTextDisabled = props.value;
      setInputValue(inputTextDisabled);
    }
  }, []);
  var onChange = function onChange2(event) {
    return handleOnChange && handleOnChange(event.target.value);
  };
  var setInputFocus = function setInputFocus2() {
    var _ref2;
    var refInput = props.refInput;
    (_ref2 = (refInput === null || refInput === void 0 ? void 0 : refInput.current) || inputRef.current) === null || _ref2 === void 0 || _ref2.focus();
  };
  var onBlur = function onBlur2(event) {
    var inputText = event.target.value;
    setInputValue(inputText);
  };
  var createLabel = function createLabel2(ellipsisStatus, labelType, value) {
    var labelText = null;
    switch (labelType) {
      case "titleLabel":
        labelText = /* @__PURE__ */ import_react.default.createElement(import_EnhancedInput.StyledTitleLabel, {
          disabled,
          icon: props.icon,
          placeholder: props.placeholder,
          required,
          htmlFor: props.name,
          inputValue,
          ref: titleLabelRef,
          darkMode,
          variant: disabled || readOnly ? "regular" : variant,
          "data-testid": "enhancedInput-titleLabel"
        }, props.titleLabel);
        break;
      case "errorLabel":
        labelText = /* @__PURE__ */ import_react.default.createElement(import_EnhancedInput.StyledIconLabelContainer, {
          darkMode,
          role: "alert"
        }, /* @__PURE__ */ import_react.default.createElement(import_Icon.Icon, {
          size: 17,
          icon: "warning"
        }), /* @__PURE__ */ import_react.default.createElement(import_EnhancedInput.StyledErrorLabel, {
          ref: errorLabelRef,
          htmlFor: props.name
        }, props.errorText));
        break;
      case "infoTextLabel":
        labelText = /* @__PURE__ */ import_react.default.createElement(import_EnhancedInput.StyledInfoTextContainer, {
          darkMode,
          role: "alert"
        }, /* @__PURE__ */ import_react.default.createElement(import_Icon.Icon, {
          size: 17,
          icon: "warning"
        }), /* @__PURE__ */ import_react.default.createElement(import_EnhancedInput.StyledInfoLabel, {
          darkMode,
          ref: infoTextLabelRef,
          htmlFor: props.name
        }, props.infoText));
        break;
      default:
        break;
    }
    if (ellipsisStatus) {
      return /* @__PURE__ */ import_react.default.createElement(import_atoms.Tooltip, {
        customizedHeight: "auto",
        value
      }, labelText);
    }
    return labelText;
  };
  return /* @__PURE__ */ import_react.default.createElement(import_react.default.Fragment, null, /* @__PURE__ */ import_react.default.createElement(import_EnhancedInput.StyledFullEnhancedInputProps, {
    readOnly,
    variant: disabled || readOnly ? "regular" : variant,
    disabled: disabled || isAriaDisabled,
    required,
    icon: props.icon,
    darkMode,
    customWidth: props.customWidth,
    onClick: function onClick() {
      return setInputFocus();
    },
    "data-testid": "enhancedInput"
  }, props.icon && /* @__PURE__ */ import_react.default.createElement(import_EnhancedInput.StyledIcon, {
    variant: disabled || readOnly ? "regular" : variant,
    darkMode,
    icon: props.icon,
    size: 18,
    disabled
  }), /* @__PURE__ */ import_react.default.createElement(import_EnhancedInput.StyledInput, _extends({
    id: props.id || inputId,
    name: props.name,
    onChange,
    placeholder: props.placeholder,
    "aria-label": props.ariaLabelEnhancedInputName || props.titleLabel || "Input",
    "aria-disabled": isAriaDisabled,
    readOnly: readOnly || isAriaDisabled,
    disabled,
    required,
    variant: disabled || readOnly ? "regular" : variant,
    icon: props.icon,
    onBlur,
    darkMode,
    ref: props.refInput || inputRef,
    "data-testid": "enhancedInput-input"
  }, props)), createLabel(isTitleEllipsisActive, "titleLabel", props.titleLabel)), /* @__PURE__ */ import_react.default.createElement(import_EnhancedInput.StyledMessagesProps, {
    variant: disabled || readOnly ? "regular" : variant
  }, !valid && !disabled && createLabel(isErrorEllipsisActive, "errorLabel", props.errorText), props.infoText && valid && createLabel(isInfoEllipsisActive, "infoTextLabel", props.infoText)));
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  EnhancedInput
});
//# sourceMappingURL=EnhancedInput.component.js.map